<script setup lang="ts">
  import { QuoteWidget } from '@/widgets'
</script>

<template>
  <QuoteWidget />
</template>
